// @ts-nocheck
/* eslint-disable */
export const menuVertIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 5.037a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37m0 4.148a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37m0 4.148a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37"/></svg>`,
    name: 'menu-vert' as const
};